import $ from 'jquery';
import debug from 'debug';

const log = debug('components/search/search-result-filter-panel');
const select = {
	ALL_CHECKBOX: '[data-search-filter-panel__choice-all]',
	CHOICE_CHECKBOX: '[data-search-filter-panel__choice]',
	FILTER_GROUP: '[data-search-filter-panel__group]',
	VALUE_INPUT: '[data-search-filter-panel__group-values]'
};

$(() => {
	$(select.ALL_CHECKBOX).on('change', function() {
		if (!this || !this.checked) {
			return;
		}
		const allCheckbox = $(this);
		const thisGroup = allCheckbox.parents(select.FILTER_GROUP);
		const allOptions = thisGroup.find(select.CHOICE_CHECKBOX);
		const valueInput = thisGroup.find(select.VALUE_INPUT);

		allOptions.each((index, choice) => {
			choice.checked = false;
		});

		valueInput.val('');
	});

	$(select.CHOICE_CHECKBOX).on('change', function() {
		const thisOption = $(this);
		const thisGroup = thisOption.parents(select.FILTER_GROUP);
		const allCheckbox = thisGroup.find(select.ALL_CHECKBOX);
		const allOptions = thisGroup.find(select.CHOICE_CHECKBOX);
		const valueInput = thisGroup.find(select.VALUE_INPUT);

		const collatedValue = allOptions
			.filter(':checked')
			.map((index, input) => {
				return input.value;
			})
			.get()
			.join();

		allCheckbox.prop('checked', false);
		valueInput.val(collatedValue);
	});

	log('mounted');
});



// WEBPACK FOOTER //
// ./project/client/src/site__vegkit/components/search/results-filter/search-results-filter-panel.js